import styled from "styled-components";

export const TopbarIconBelowLabelDiv = styled.div`
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
`;
